module.exports = __webpack_public_path__ + "assets/img/bob_barker-9bb1020b.jpg";